import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map, Observable } from 'rxjs';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';
import { ConfirmationOptions, NOTICE_TEST_IDS } from './confirmation-dialog.models';

/** Panel class of every confirmation dialog (sets its width). */
export const CONFIRMATION_DIALOG_PANEL = 'app-confirmation-dialog-panel';

/** Opens the app's confirmation dialogs, so they all look and behave the same. */
@Injectable({ providedIn: 'root' })
export class ConfirmationDialogService {
  constructor(private readonly dialog: MatDialog) {}

  /**
   * Asks the user to confirm. Emits once when the dialog closes: true when the user confirmed (and the action,
   * if any, completed), false when they cancelled or closed it.
   */
  confirm(options: ConfirmationOptions): Observable<boolean> {
    return this.dialog
      .open<ConfirmationDialogComponent, ConfirmationOptions, boolean>(ConfirmationDialogComponent, {
        data: options,
        panelClass: CONFIRMATION_DIALOG_PANEL,
        width: '580px',
        maxWidth: 'calc(100vw - 32px)',
        disableClose: options.disableClose ?? false,
      })
      .afterClosed()
      .pipe(map((confirmed) => confirmed === true));
  }

  /** Shows a message with a single Close button. Emits once when it is closed. */
  notice(message: string, title = 'Notice'): Observable<void> {
    return this.confirm({
      title,
      message,
      confirmLabel: 'Close',
      hideCancel: true,
      disableClose: true,
      testIds: NOTICE_TEST_IDS,
    }).pipe(map(() => undefined));
  }
}
